var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "add_a_photo_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.277,
    height: 24.277,
    viewBox: "0 0 24.277 24.277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M0,0H24.277V24.277H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M21.243,6.058H18.036L16.185,4.035H10.116V6.058h5.179l1.851,2.023h4.1V20.219H5.058v-9.1H3.035v9.1a2.029,2.029,0,0,0,2.023,2.023H21.243a2.029,2.029,0,0,0,2.023-2.023V8.081A2.029,2.029,0,0,0,21.243,6.058ZM8.092,14.15A5.058,5.058,0,1,0,13.15,9.092,5.06,5.06,0,0,0,8.092,14.15Zm5.058-3.035a3.035,3.035,0,1,1-3.035,3.035A3.044,3.044,0,0,1,13.15,11.116ZM5.058,6.058H8.092V4.035H5.058V1H3.035V4.035H0V6.058H3.035V9.092H5.058Z",
    transform: "translate(0 0.012)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImg);
export default __webpack_public_path__ + "static/media/add_img.5d2c3833b0aaf34b97c1b2edee0997c3.svg";
export { ForwardRef as ReactComponent };